<template>
  <v-dialog v-model="shown" persistent :maximized="isMobile" max-width="500">
    <v-card v-if="item" style="height: 329px;" >
      <v-card-text class="row popup-header">
        <div class="col-10">
          <div class="title">{{item.name}}</div>
        </div>
        <div class="col-2">
          <v-btn class="close float-right" size="lg" icon="fas fa-window-close" text rounded dense @click="remove" />
        </div>
      </v-card-text>

      <v-card-text class="popup-body scroll">
        <v-form
          @submit="save"
          class="q-mb-lg"
        >
          <div class="row" v-if="item.ask_for_quantity">
            <div class="col-3">
              <v-btn
                text
                type="button"
                color="white"
                class="quantityBtn"
                @click="subtractQuantity"
              >-</v-btn>
            </div>
            <div class="col-6">
              <!-- :autofocus="!item.ask_for_price && !isMobile" -->
              <PopupArticlePriceAndQuantityInput
                :autofocus="false"
                v-model="newQuantity"
                @click="focusedElement = 1"
                @blur="parseNewQuantity"
              />
            </div>
            <div class="col-3 text-right">
              <v-btn
                text
                type="button"
                color="white"
                class="quantityBtn"
                @click="addQuantity"
              >+</v-btn>
            </div>
          </div>
          <div class="label q-mb-sm q-mt-md" v-if="item.ask_for_quantity">Izbrana količina</div>
          <div class="row" v-if="item.ask_for_quantity">
            <div class="col-12" style="font-size: 30px;" :inner-html.prop="form.quantity">
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-text class="popup-footer">
        <v-btn text type="button" class="float-right mr-4" style="background-color: #0F998E; color: #fff!important;" @click="save">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" style="background-color: #ED7F78; color: #fff;" @click="remove">Prekliči</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import PopupArticlePriceAndQuantityInput from './PopupArticlePriceAndQuantityInput'

export default {
  components: {
    PopupArticlePriceAndQuantityInput,
    // Keyboard: () => import('./PopupVirtualNumericKeyboard'),
  },
  data () {
    return {
      item: null,
      focusedElement: 0,
      screenOrientation: null,
      form: {
        quantity: null,
        name: null,
      },
      newPrice: '',
      newQuantity: 1,
      newName: '',
      shown: false,
    }
  },
  created () {
    this.focusedElement = 0
  },
  mounted () {
    this.screenOrientation = window.screen.orientation.type.toLowerCase().includes('landscape')
  },
  computed: {
    ...mapGetters(['isMobile']),
    isCordova () {
      return false
    },
  },
  methods: {
    setChanged (val) {
      if (this.focusedElement === 0) {
        this.newPrice = val
      } else if (this.focusedElement === 1) {
        this.newQuantity = val
      }
    },
    save () {
      this.shown = false
      this.resolve({ fina: (parseFloat(this.newQuantity) * this.item.value), id: this.item.id })
    },
    subtractQuantity () {
      let quantity = parseInt(this.form.quantity)
      quantity -= 1
      // if (quantity >= 0) {
      this.newQuantity = quantity
      // }
    },
    addQuantity () {
      let quantity = parseInt(this.form.quantity)
      quantity += 1
      this.newQuantity = quantity
    },
    subtractPrice () {
      let price = this.parseNewPrice(this.newPrice)
      price -= 1
      this.newPrice = price
    },
    addPrice () {
      let price = this.parseNewPrice(this.newPrice)
      price += 1
      this.newPrice = price
    },
    parseNewPrice () {
      if (!this.newPrice) return this.item.price
      const price = parseFloat((`${this.newPrice}`).replace(',', '.'))
      if (isNaN(price)) return this.item.price
      if (price < 0) return 0
      return price
    },
    parseNewQuantity () {
      if (!this.newQuantity) return '1,00'
      if (this.newQuantity < 0) return 0
      return this.newQuantity
    },
    open (item) {
      this.item = item
      this.newPrice = ''
      this.newQuantity = 1
      this.newName = item.name
      // this.form.price = item.price
      this.shown = true
      this.focusedElement = 1
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    remove () {
      this.shown = false
      this.resolve({ fina: (0 * this.item.value), id: this.item.id })
      // this.resolve()
    },
  },
  watch: {
    newPrice (newPrice) {
      this.form.price = this.parseNewPrice(newPrice)
    },
    newQuantity (newQuantity) {
      this.form.quantity = this.parseNewQuantity(newQuantity)
    },
    newName (newName) {
      this.form.name = newName
    },
    focusedElement (val) {
      if (this.$refs.keyboard) {
        this.$refs.keyboard.clearVnos()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .hideKeyboard {
    display: none !important;
  }
  .title {
    font-size: 21px;
  }
  .close {
    color: rgb(237, 127, 120);
  }
  .v-dialog .v-card {
    // width: 350px;
    max-height: 95vh !important;
    height: 95vh;
  }

  .popup-header {
    height: 70px;
  }
  .popup-body {
    width: 100%;
    padding: 20px;
    padding-top: 0px;
    padding-bottom: 0px;
    max-height: calc(100vh - 168px);
  }
  .popup-footer {
    height: 60px;
  }

  .label {
    color: gray;
  }
  .quantityBtn {
    width: 40px;
    background-color: #0F998E;
    font-weight: bold;
    font-size: 21px;
  }
  .total {
    font-size: 22px;
    margin: 5px 0 25px 0;
  }
  .btn-row {
    height: 20px;
    margin-top: 30px;
  }

  .hr-breakpoint-mobile {
    .q-dialog__inner .q-card {
      width: 100vw;
      max-height: 100vh !important;
    }
    .popup-body {
      width: 100vw;
      max-height: calc(100vh - 130px) !important;
    }
    .q-card {
      position: relative;

      .popup-footer {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
</style>
